@if ( loading ) {
<div class="container mt-4 mb-5">
  <div class="clearfix">

    <!-- Left Main Column (Book Info) Skeleton -->
    <div class="col-12 col-lg-8 float-lg-start mb-4">
      <div class="row">
        <!-- Cover & Stats (Col-3) -->
        <div class="col-md-3 mt-4">
          <!-- Cover -->
          <div style="aspect-ratio: 2/3;" class="w-100 rounded mb-3 placeholder-glow bg-light">
            <span class="placeholder w-100 h-100" style="opacity: 0.1;"></span>
          </div>

          <!-- Stats (Grid of 4) -->
          <div class="row g-2 mt-3 placeholder-glow">
            <div class="col-6"><span class="placeholder col-12 py-4 rounded bg-light border"></span></div>
            <div class="col-6"><span class="placeholder col-12 py-4 rounded bg-light border"></span></div>
            <div class="col-6"><span class="placeholder col-12 py-4 rounded bg-light border"></span></div>
            <div class="col-6"><span class="placeholder col-12 py-4 rounded bg-light border"></span></div>
          </div>
        </div>

        <!-- Details (Col-9) -->
        <div class="col-md-9 mt-4 ps-md-4">
          <!-- Title -->
          <h3 class="placeholder-glow mb-3"><span class="placeholder col-10"></span></h3>
          <h3 class="placeholder-glow mb-4"><span class="placeholder col-6"></span></h3>

          <!-- Info Rows -->
          <p class="placeholder-glow mb-2"><span class="placeholder col-3 me-2"></span><span
              class="placeholder col-6"></span></p>
          <p class="placeholder-glow mb-2"><span class="placeholder col-3 me-2"></span><span
              class="placeholder col-5"></span></p>
          <p class="placeholder-glow mb-2"><span class="placeholder col-3 me-2"></span><span
              class="placeholder col-8"></span></p>
          <p class="placeholder-glow mb-2"><span class="placeholder col-3 me-2"></span><span
              class="placeholder col-4"></span></p>

          <!-- Action Buttons -->
          <div class="d-flex gap-2 mt-4 placeholder-glow">
            <span class="placeholder col-2 py-2 rounded-pill"></span>
            <span class="placeholder col-2 py-2 rounded-pill"></span>
            <span class="placeholder col-1 py-3 rounded-circle ms-auto"></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column (Items) Skeleton -->
    <div class="col-12 col-lg-4 float-lg-end mt-4 mt-lg-0 ps-lg-4">
      <div class="border rounded p-3 bg-white shadow-sm">
        <h5 class="placeholder-glow mb-3"><span class="placeholder col-5"></span></h5>
        <hr>
        <div class="placeholder-glow my-3">
          <span class="placeholder col-12 mb-2 p-3 rounded"></span>
          <span class="placeholder col-12 mb-2 p-3 rounded"></span>
          <span class="placeholder col-12 mb-2 p-3 rounded"></span>
        </div>
      </div>
    </div>

    <!-- Bottom Content (Abstract/Subject) Skeleton -->
    <div class="col-12 col-lg-8 float-lg-start mt-2">
      <div class="mb-4">
        <span class="placeholder col-2 mb-2 d-block h5"></span>
        <div class="d-flex gap-2 placeholder-glow">
          <span class="placeholder col-2 py-2 rounded-pill"></span>
          <span class="placeholder col-3 py-2 rounded-pill"></span>
          <span class="placeholder col-2 py-2 rounded-pill"></span>
        </div>
      </div>

      <div class="mb-4">
        <span class="placeholder col-3 mb-2 d-block h5"></span>
        <p class="placeholder-glow">
          <span class="placeholder col-12 mb-1"></span>
          <span class="placeholder col-12 mb-1"></span>
          <span class="placeholder col-12 mb-1"></span>
          <span class="placeholder col-8"></span>
        </p>
      </div>
    </div>

  </div>
</div>
} @else {

<div *ngIf="bibid != '' && bibid != null && this.validParameter" class="container mt-4">
  <div class="clearfix">

    <div id="moduleBook" class="col-12 col-lg-8 float-lg-start mb-4">
      <div class="row">
        <div class="col-md-3 mt-4">
          <div class="book-cover-container">
            <div class="DivBookCover position-relative book-cover-card">

              <app-book-cover-share [bookCoverURL]="bookcoverUrl" [id]="bibid"
                [cssStyle]="'img-fluid w-100 book-cover-image'" [title]="title | shortTitle : 35">
              </app-book-cover-share>
              <button *ngIf="covers.length > 0" type="button" data-bs-toggle="modal" data-bs-target="#bookcoverAllModal"
                class="btn-zoom-cover">
                <i class="bi bi-zoom-in"></i>
              </button>
            </div>
          </div>

          <!-- Stats Section (Compact Sidebar) -->
          <div class="row g-2 mt-3">
            <!-- Checkouts -->
            <div class="col-3 col-md-6">
              <div
                class="d-flex flex-column align-items-center justify-content-center py-2 px-1 rounded-3 bg-light border h-100">
                <div class="mb-1 d-md-none"
                  [ngClass]="bookStatic.CHECKOUTCOUNT > 0 ? 'text-success' : 'text-secondary'"><i
                    class="bi bi-book-fill fs-6"></i></div>
                <div class="fw-bold lh-1 small"
                  [ngClass]="bookStatic.CHECKOUTCOUNT > 0 ? 'text-dark' : 'text-secondary'">{{ bookStatic.CHECKOUTCOUNT
                  }}</div>
                <div class="text-muted text-uppercase d-none d-sm-block" style="font-size: 0.6rem;">{{ 'Checkouts' |
                  translate }}</div>
              </div>
            </div>

            <!-- Downloads -->
            <div class="col-3 col-md-6" *ngIf="book856.length > 0">
              <div
                class="d-flex flex-column align-items-center justify-content-center py-2 px-1 rounded-3 bg-light border h-100">
                <div class="mb-1 d-md-none" [ngClass]="bookStatic.DOWNLOAD > 0 ? 'text-primary' : 'text-secondary'"><i
                    class="bi bi-cloud-arrow-down-fill fs-6"></i></div>
                <div class="fw-bold lh-1 small" [ngClass]="bookStatic.DOWNLOAD > 0 ? 'text-dark' : 'text-secondary'">{{
                  bookStatic.DOWNLOAD }}</div>
                <div class="text-muted text-uppercase d-none d-sm-block" style="font-size: 0.6rem;">{{ 'Downloads' |
                  translate }}</div>
              </div>
            </div>

            <!-- Views -->
            <div class="col-3 col-md-6">
              <div
                class="d-flex flex-column align-items-center justify-content-center py-2 px-1 rounded-3 bg-light border h-100">
                <div class="mb-1 d-md-none" [ngClass]="bookStatic.OPACVIEW > 0 ? 'text-info' : 'text-secondary'"><i
                    class="bi bi-eye-fill fs-6"></i></div>
                <div class="fw-bold lh-1 small" [ngClass]="bookStatic.OPACVIEW > 0 ? 'text-dark' : 'text-secondary'">{{
                  bookStatic.OPACVIEW }}</div>
                <div class="text-muted text-uppercase d-none d-sm-block" style="font-size: 0.6rem;">{{ 'Views' |
                  translate }}</div>
              </div>
            </div>

            <!-- My List -->
            <div class="col-3 col-md-6">
              <div
                class="d-flex flex-column align-items-center justify-content-center py-2 px-1 rounded-3 bg-light border h-100">
                <div class="mb-1 d-md-none"
                  [ngClass]="bookStatic.MYLIST > 0 ? 'text-walai-default-color' : 'text-secondary'"><i
                    class="bi bi-heart-fill fs-6"></i></div>
                <div class="fw-bold lh-1 small" [ngClass]="bookStatic.MYLIST > 0 ? 'text-dark' : 'text-secondary'">{{
                  bookStatic.MYLIST }}</div>
                <div class="text-muted text-uppercase d-none d-sm-block" style="font-size: 0.6rem;">{{ 'Collections' |
                  translate }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-9 flex-column position-static ps-md-4 pe-md-4 mt-4">
          <ngx-spinner bdOpacity="0.9" bdColor="" size="default" color="#581f87" type="ball-pulse-sync"
            [fullScreen]="false">
          </ngx-spinner>
          <div class="d-flex">
            <img *ngIf="mattyeIcon" src="{{ mattyeIcon }}" class="bd-placeholder-img rounded-circle" width="25"
              height="25" />
            <p class="media-body pb-2 mb-0 ms-2">
              <strong class="d-block" style="font-size: 18px">{{ title }}</strong>
            </p>
          </div>

          <!-- Info List -->
          <div class="book-info-list">

            <!-- Additional Title(s) -->
            <ng-container *ngFor="let group of groupedInfoList">
              <div class="info-row" *ngIf="group.field === 'Additional Title(s)'">
                <div class="info-label-col">
                  <span>{{ group.field | translate }}</span>
                </div>
                <div class="info-value-col">
                  <div class="info-value-text">
                    <ng-container *ngFor="let value of group.values; let last = last">
                      <span>{{ value }}</span>
                      <span *ngIf="!last" class="me-1">,</span>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Author -->
            <div class="info-row" *ngIf="haveAuthor">
              <div class="info-label-col">
                <span>{{ "Author" | translate }}</span>
              </div>
              <div class="info-value-col">
                <div class="d-flex flex-wrap align-items-center">
                  <ng-container *ngFor="let info of authorList; let last = last">
                    <a class="text-primary text-decoration-none" target="_blank"
                      [href]="locationID ? 'results?Ntk=AUTHOR|LOCATION&Ntt=' + info.DATA + '|' + locationID : 'results?Ntk=AUTHOR&Ntt=' + info.DATA">
                      {{ info.DATA }}
                    </a>
                    <span *ngIf="info.DATA_SUFFIX" class="text-muted ms-1">{{ info.DATA_SUFFIX }}</span>
                    <span *ngIf="!last" class="me-2">,</span>
                  </ng-container>
                </div>
              </div>
            </div>

            <!-- Added Author -->
            <div class="info-row" *ngIf="addedAuthor">
              <div class="info-label-col">
                <span>{{ "AddedAuthor" | translate }}</span>
              </div>
              <div class="info-value-col">
                <div class="d-flex flex-wrap align-items-center">
                  <ng-container
                    *ngFor="let info of addedAuthorList | slice:0:(isAddedAuthorExpanded ? addedAuthorList.length : 10); let last = last">
                    <a class="text-primary text-decoration-none" target="_blank"
                      [href]="locationID ? 'results?Ntk=AUTHOR|LOCATION&Ntt=' + info.DATA + '|' + locationID : 'results?Ntk=AUTHOR&Ntt=' + info.DATA">
                      {{ info.DATA }}
                    </a>
                    <span *ngIf="info.DATA_SUFFIX" class="text-muted ms-1">{{ info.DATA_SUFFIX }}</span>
                    <span *ngIf="!last" class="me-2">,</span>
                  </ng-container>
                  <a *ngIf="addedAuthorList.length > 10" (click)="isAddedAuthorExpanded = !isAddedAuthorExpanded"
                    class="info-tag-more ms-1">
                    <span *ngIf="!isAddedAuthorExpanded">+{{ addedAuthorList.length - 10 }} {{ 'More' | translate
                      }}</span>
                    <span *ngIf="isAddedAuthorExpanded">{{ 'ShowLess' | translate }}</span>
                  </a>
                </div>
              </div>
            </div>

            <!-- ISBN -->
            <div class="info-row" *ngIf="haveISBN">
              <div class="info-label-col">
                <span>{{ "ISBN" | translate }}</span>
              </div>
              <div class="info-value-col">
                <div class="info-value-text d-flex flex-wrap align-items-center">
                  <ng-container *ngFor="let isbn of isbnList; let last = last">
                    <span>{{ isbn.DATA }}</span>
                    <span *ngIf="!last" class="me-1">,</span>
                  </ng-container>
                </div>
              </div>
            </div>

            <!-- Grouped Info List -->
            <ng-container *ngIf="groupedInfoList && groupedInfoList.length > 0">
              <ng-container *ngFor="let group of groupedInfoList; trackBy: trackByField">
                <div class="info-row" *ngIf="group.field !== 'Additional Title(s)'">
                  <div class="info-label-col">
                    <span>{{ group.field | translate }}</span>
                  </div>
                  <div class="info-value-col">
                    <!-- Source field (clickable link) -->
                    <ng-container *ngIf="group.field === 'Source'; else checkPublished">
                      <div class="d-flex flex-wrap gap-1">
                        <ng-container *ngFor="let value of group.values">
                          <a class="info-tag info-tag-clickable" target="_blank"
                            href="results?Ntk=JOURNALTITLE&Ntt={{ value }}" [title]="value">
                            {{ value }}
                          </a>
                        </ng-container>
                      </div>
                    </ng-container>

                    <!-- Published field -->
                    <ng-template #checkPublished>
                      <ng-container *ngIf="group.field === 'Published'; else normalDisplay">
                        <div class="info-value-text">
                          <ng-container *ngFor="let value of group.values; let last = last">
                            <span>{{ value }}</span>
                            <span *ngIf="!last" class="me-1">,</span>
                          </ng-container>
                        </div>
                      </ng-container>
                    </ng-template>

                    <!-- Normal display -->
                    <ng-template #normalDisplay>
                      <div class="info-value-text">
                        <ng-container
                          *ngFor="let value of group.values | slice:0:(isFieldExpanded(group.field) ? group.values.length : 3); let i = index; let last = last">
                          <span [class.line-clamp-2]="!isValueExpanded(group.field, i) && value.length > 100"
                            [style.display]="group.field === 'General Note' ? 'block' : 'inline'">
                            {{ value }}
                          </span>
                          <a *ngIf="value.length > 100 && !isValueExpanded(group.field, i)"
                            (click)="toggleValueExpansion(group.field, i); $event.preventDefault()"
                            class="info-tag-more ms-1">{{ 'More' | translate }}</a>
                          <a *ngIf="isValueExpanded(group.field, i)"
                            (click)="toggleValueExpansion(group.field, i); $event.preventDefault()"
                            class="info-tag-more ms-1">{{ 'Less' | translate }}</a>
                          <ng-container *ngIf="!last">
                            <br *ngIf="group.field === 'General Note'">
                            <span *ngIf="group.field !== 'General Note'" class="me-1">,</span>
                          </ng-container>
                        </ng-container>
                        <a *ngIf="group.values.length > 3"
                          (click)="toggleFieldExpansion(group.field); $event.preventDefault()"
                          class="info-tag-more ms-2">
                          <span *ngIf="!isFieldExpanded(group.field)">+{{ group.values.length - 3 }} {{ 'More' |
                            translate }}</span>
                          <span *ngIf="isFieldExpanded(group.field)">{{ 'ShowLess' | translate }}</span>
                        </a>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <div class="col-12 mb-3" *ngIf="book856.length > 0">
            <div class="d-flex flex-column gap-1">
              <ng-container *ngFor="let info of book856">
                <a (click)="addHistory(info.URL)" [href]="info.URL" target="_blank"
                  class="d-flex align-items-center py-2 px-3 rounded-2 text-decoration-none e-resource-link"
                  style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%); border: 1px solid #e2e8f0;">

                  <!-- Icon -->
                  <div class="shrink-0 d-flex align-items-center justify-content-center me-2 rounded-circle"
                    style="width: 32px; height: 32px; background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);">
                    <i class="bi bi-link-45deg text-white" style="font-size: 1rem;"></i>
                  </div>

                  <!-- Text Info -->
                  <div class="grow overflow-hidden">
                    <div class="d-flex align-items-center gap-2">
                      <span *ngIf="info.label" class="text-uppercase text-secondary"
                        style="font-size: 0.6rem; letter-spacing: 0.05em; font-weight: 600;">
                        {{ info.label }} •
                      </span>
                      <span class="text-dark fw-semibold text-truncate" style="font-size: 0.875rem;"
                        [title]="info.name">
                        {{ info.name }}
                      </span>
                    </div>
                  </div>

                  <!-- Arrow -->
                  <div class="ms-2 text-primary">
                    <i class="bi bi-arrow-right" style="font-size: 0.75rem;"></i>
                  </div>
                </a>
              </ng-container>
            </div>
          </div>

          <div class="col-12 mb-3 px-2">


            <!-- Action Buttons -->
            <div class="d-flex flex-wrap align-items-center gap-2 w-100 mt-2">
              <!-- Export -->
              <app-export [bibid]="bibid"></app-export>

              <!-- Save -->
              <button *ngIf="isArticle == false" type="button"
                class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark px-3 shadow-none"
                (click)="save(bibid)">
                <i class="bi bi-bookmark-plus"></i> <span class="ms-1">{{ 'Save' | translate }}</span>
              </button>

              <!-- Digital Resource -->
              <div *ngIf="opacopenRD">
                <app-btn-rd [item]="bibid" [BLOCKUSER]="BLOCKUSER" [mattypeID]="9"
                  [NDDUserPrivilege]="NDDUserPrivilege"></app-btn-rd>
              </div>

              <!-- Add to Collection -->
              <app-collection [bibid]="bibid" [page]="'bibitem'"></app-collection>

              <!-- Share (Pushed to right) -->
              <div class="ms-auto">
                <app-share-facebook [shareUrl]="url"></app-share-facebook>
              </div>
            </div>

            <div class="d-flex align-items-center w d-none">
              <app-export [bibid]="bibid"></app-export>

              <button *ngIf="isArticle == false" type="button"
                class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark me-2" (click)="save(bibid)">
                <span><i class="bi bi-file-earmark-arrow-down"></i> {{ 'Save' | translate }}
                </span>
              </button>

              <div *ngIf="opacopenRD">
                <app-btn-rd [item]="bibid" [BLOCKUSER]="BLOCKUSER" [mattypeID]="9"
                  [NDDUserPrivilege]="NDDUserPrivilege"></app-btn-rd>
              </div>
              <app-collection [bibid]="bibid" [page]="'bibitem'"></app-collection>
              <app-share-facebook [shareUrl]="url"></app-share-facebook>
            </div>
          </div>

          <div class="col-12 mb-3 p-2 d-none">
            <div class="row row-cols-auto justify-content-between mb-2">
              <!-- <div class="d-flex justify-content-center mb-2">
                <span class="text-walai-default-color me-3 fs-6">
                  <i class="bi bi-book-fill"></i>
                  {{ bookStatic.CHECKOUTCOUNT }}</span>
                <span *ngIf="book856.length > 0" class="text-walai-default-color fs-6 me-3">
                  <i class="bi bi bi-cloud-arrow-down-fill"></i>
                  {{ bookStatic.DOWNLOAD }}</span>
                <span class="text-walai-default-color me-3 fs-6">
                  <i class="bi bi-eye-fill"></i>
                  {{ bookStatic.OPACVIEW }}</span>
                <span class="text-walai-default-color fs-6">
                  <i class="bi bi-heart-fill"></i>
                  {{ bookStatic.MYLIST }}</span>
              </div> -->

              <!-- Redesigned Stats Section (Horizontal Layout) -->
              <div class="row g-3 mb-4 mt-1 border-top pt-3">
                <!-- Checkouts -->
                <div class="col-6 col-sm-3">
                  <div class="d-flex align-items-center justify-content-center p-2 rounded-3 bg-light border h-100">
                    <div class="text-success me-3"><i class="bi bi-book-fill fs-4"></i></div>
                    <div class="text-start">
                      <div class="fw-bold fs-5 lh-1 text-dark">{{ bookStatic.CHECKOUTCOUNT }}</div>
                      <div class="text-muted small text-uppercase" style="font-size: 0.7rem;">{{ 'Checkouts' | translate
                        }}</div>
                    </div>
                  </div>
                </div>

                <!-- Downloads -->
                <div class="col-6 col-sm-3" *ngIf="book856.length > 0">
                  <div class="d-flex align-items-center justify-content-center p-2 rounded-3 bg-light border h-100">
                    <div class="text-primary me-3"><i class="bi bi-cloud-arrow-down-fill fs-4"></i></div>
                    <div class="text-start">
                      <div class="fw-bold fs-5 lh-1 text-dark">{{ bookStatic.DOWNLOAD }}</div>
                      <div class="text-muted small text-uppercase" style="font-size: 0.7rem;">{{ 'Downloads' | translate
                        }}</div>
                    </div>
                  </div>
                </div>

                <!-- Views -->
                <div class="col-6 col-sm-3">
                  <div class="d-flex align-items-center justify-content-center p-2 rounded-3 bg-light border h-100">
                    <div class="text-info me-3"><i class="bi bi-eye-fill fs-4"></i></div>
                    <div class="text-start">
                      <div class="fw-bold fs-5 lh-1 text-dark">{{ bookStatic.OPACVIEW }}</div>
                      <div class="text-muted small text-uppercase" style="font-size: 0.7rem;">{{ 'Views' | translate }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- My List -->
                <div class="col-6 col-sm-3">
                  <div class="d-flex align-items-center justify-content-center p-2 rounded-3 bg-light border h-100">
                    <div class="text-walai-default-color me-3"><i class="bi bi-heart-fill fs-4"></i></div>
                    <div class="text-start">
                      <div class="fw-bold fs-5 lh-1 text-dark">{{ bookStatic.MYLIST }}</div>
                      <div class="text-muted small text-uppercase" style="font-size: 0.7rem;">{{ 'Collections' |
                        translate }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex align-items-center">
                <app-export [bibid]="bibid"></app-export>

                <button *ngIf="isArticle == false" type="button"
                  class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark rounded-pill me-2"
                  (click)="save(bibid)">
                  <span><i class="bi bi-file-earmark-arrow-down"></i> {{ 'Save' | translate }}
                  </span>
                </button>

                <div *ngIf="opacopenRD">
                  <app-btn-rd [item]="bibid" [BLOCKUSER]="BLOCKUSER" [mattypeID]="9"
                    [NDDUserPrivilege]="NDDUserPrivilege"></app-btn-rd>
                </div>
                <app-collection [bibid]="bibid" [page]="'bibitem'"></app-collection>
                <app-share-facebook [shareUrl]="url"></app-share-facebook>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ITEMS for Mobile : Ordered 2nd in DOM to appear between Book and Content on Mobile -->
    <aside id="moduleItems" class="col-12 col-lg-4 float-lg-end mt-4 mt-lg-0 ps-lg-4">
      <ng-template [ngIf]="isBook == true">
        <app-items [bibid]="bibid" [title]="title" [mattypeID]="mattypeID"></app-items>
      </ng-template>
    </aside>

    <div id="moduleContent" class="col-12 col-lg-8 float-lg-start mt-2">
      <div class="row mb-2" *ngIf="havesubject">
        <div id="moduleSubject" class="col-12">
          <p> <strong class="info-label">{{
              "Subject" | translate
              }}</strong></p>
          <ng-container *ngFor="let s of subjectList">
            <a target="_blank" type="button"
              [href]="locationID ? 'results?Ntk=SUBJECT|LOCATION&Ntt=&quot;' + s.DATA + '&quot;|' + locationID : 'results?Ntk=SUBJECT&Ntt=&quot;' + s.DATA + '&quot;'"
              class="btn btn-outline-secondary btn-light-walai me-2 mb-2 btn-sm">
              {{ s.DATA }}
            </a>
          </ng-container>
        </div>
      </div>

      <div class="row mb-2 mt-4" *ngIf="contents.length > 0">
        <div id="moduleTableOfContents" class="col-12">
          <strong class="info-label">{{ "TableOfContents" | translate }}</strong>
          <p class="text-body ps-4 mt-3 collapse" id="collapseTableOfContents" aria-expanded="false">
            <small *ngFor="let Content of contents">- {{ replaceBR (Content) }} <br /></small>
          </p>
          <a class="collapsed a-walai text-primary text-decoration-underline" data-bs-toggle="collapse"
            href="#collapseTableOfContents" aria-expanded="false" aria-controls="collapseTableOfContents"
            [attr.data-content-collapsed]="'SeeAll' | translate"
            [attr.data-content-expanded]="'Collapse' | translate"></a>
        </div>
      </div>

      <div class="row mb-2 mt-4" *ngIf="abstract">
        <div class="col-12">
          <strong class="info-label">{{ "Description" | translate }}</strong>
          <p class="text-body ps-4 mt-3">{{ abstract }}</p>
        </div>
      </div>

      <div class="row mb-4 mt-4">
        <div class="col-12">
          <div class="d-flex my-auto gap-2">
            <app-marc [bibid]="bibid"></app-marc>
            <app-holding [bibid]="bibid" *ngIf="isSerial"></app-holding>
            <app-marcholding [bibid]="bibid" *ngIf="isSerial"></app-marcholding>
          </div>
        </div>
      </div>


      <div class="row mb-2 mt-5" *ngIf="bookRelated && isBook">
        <div class="col-12">
          <div class="border-bottom">
            <h5 class="info-label">
              {{ "RelatedBook" | translate }}
            </h5>
          </div>
          <!-- RelatedBook -->
          <div class="row g-4 row-cols-2 row-cols-md-4 row-cols-lg-6 mt-4">
            <div class="col" *ngFor="let b of bookRelated">
              <div class="h-100 d-flex flex-column">
                <div class="DivBookCover">
                  <a [href]="'bibitem?bibid=' + b.BIBID" class="text-decoration-none h-100 d-block">
                    <app-book-cover-share [bookCoverURL]="b.bookcoverurl" [id]="b.BIBID"
                      [cssStyle]="'img-fluid w-100 h-100'" [title]="b.TITLESHOT"></app-book-cover-share>
                  </a>
                </div>
                <a class="a-walai-book-card-view text-center" [href]="'bibitem?bibid=' + b.BIBID">{{
                  b.TITLESHOT }}</a>
                <span class="author-text-card-view text-center">{{ b.AUTHOR }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-2 mt-5" *ngIf="bookRelated && isArticle">
        <div class="col-12">
          <div class="">
            <h5 class="info-label">
              {{ "AllTitleInIssue" | translate }}
            </h5>
            <div class="article-list-container mt-4">
              <div class="article-item" *ngFor="let b of AllTitleInIssue; let i = index">
                <div class="article-number">
                  <span class="badge-number">{{ i + 1 }}</span>
                </div>
                <div class="article-content">
                  <a class="article-link" href="bibitem?bibid={{ b.JMARCID }}" target="_blank">
                    <div class="d-flex align-items-start">
                      <i class="bi bi-file-earmark-text article-icon"></i>
                      <div class="article-title-wrapper">
                        <h6 class="article-title mb-0">{{ b.TITLE }}</h6>
                      </div>
                    </div>
                    <i class="bi bi-arrow-right article-arrow"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-bib-tag-cloude [bibid]="bibid"></app-bib-tag-cloude>

      <app-review-lib [bibid]="bibid"></app-review-lib>

      <app-review-member [bibid]="bibid"></app-review-member>

    </div>

  </div>
</div>

<div *ngIf="bibid == '' || bibid == null || validParameter == false" class="container mt-5">
  <div class="row justify-content-center justify-content-md-between">
    <div class="order-0 col-lg-12">
      <div class="alert alert-danger" role="alert">{{ 'InvalidParameter' | translate }}</div>
    </div>
  </div>
</div>
}

<div class="modal fade" id="bookcoverAllModal" tabindex="-1" role="dialog" aria-labelledby="bookcoverAllModalTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="bookcoverAllModalTitle">{{ 'BookCover' | translate }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active" *ngFor="let cover of covers; let i = index"
              [ngClass]="{ active: i === 0 }">
              <img src="{{ cover }}" class="d-block w-100" alt="{{ cover }}" />
            </div>
          </div>
          <button type="button" *ngIf="covers.length > 1" class="carousel-control-prev"
            data-bs-target="#carouselExampleControls" role="button" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">{{ 'Previous' | translate }}</span>
          </button>
          <button type="button" *ngIf="covers.length > 1" class="carousel-control-next"
            data-bs-target="#carouselExampleControls" role="button" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">{{ 'Next' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>